"use strict";

import angular from "angular";

import template from "./help-item-video.component.html";
import "./themes/help-item-video.component.scss";

class HelpItemVideoComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemVideoComponent.$inject = [];

const name = "helpItemVideoComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemVideoComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
